import { Button } from "@/components/common/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/common/card";
import { Suspense } from "react";
import { Topbar } from "@/components/layout/topbar";
import { Content } from "@/components/layout/content";
import { ButtonGroup } from "@rumble-it/common-components/components";
import { ActionShow } from "@/pages/admin/rules/actions/components/actions-show";
import { Loading } from "@/components/common/loading";
import { DeleteEntityDialog } from "@/components/common/delete";
import { useParams, Link } from "react-router-dom";

export default function ActionsDetails() {
  const params = useParams();
  return (
    <>
      <Topbar
        title="Action"
        breadcrumb={[{ title: "Actions", href: "/rules/actions" }]}
      />

      <Content>
        <Card>
          <CardHeader>
            <CardTitle>Action</CardTitle>

            <ButtonGroup>
              <Link to={`/rules/actions/${params.id}/edit`}>
                <Button variant="grey">Wijzig</Button>
              </Link>

              <DeleteEntityDialog
                id={params.id}
                entityType="rules/actions"
                redirectTo="/rules/actions"
              />
            </ButtonGroup>
          </CardHeader>

          <CardContent>
            <Suspense fallback={<Loading />}>
              <ActionShow id={params.id} />
            </Suspense>
          </CardContent>
        </Card>
      </Content>
    </>
  );
}
